/**
 * api 로직
 * 리스트 가져오기
 */

import { useMutation } from "@tanstack/react-query";
import { rmOpModifyApi, rmOpsApi } from "components/api/rm";
import { PAGE_ID_ROOM_OPTION } from "components/constent";
import { apifield } from "components/utils/comm";
import { pageInitInf, timeFormat } from "components/utils/comm";
import { IPageNav } from "interface/index";
import { IRmOps } from "interface/rm/op";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import useAlertStore from "store/alert";
import useListRowInfStroe from "store/listRowInf";
import useLodStore from "store/lod";
import usePageNoStore from "store/pageNo";
import { useOptionListContext } from "../context";
import i18n from "locales/i18n";
import useModalStore from "store/modal";
import { initialPageNav } from "components/utils/comm";

// 리스트 조회
type ISearch = {
  param: any;
};
export const useSearchList = () => {
  const { t } = useTranslation();
  const lod = useLodStore((state) => state.lod);
  const pageNo = usePageNoStore((state) => state.pageNo);
  const { isSuccess, setIsSuccess, param } = useOptionListContext();

  const [rowData, setRowData] = useState<any[] | null>(null);
  const pageNavRef = useRef<IPageNav>(initialPageNav);

  const mutation = useMutation({
    mutationFn: rmOpsApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          const pageNav = res.data.pageNav;
          const rmOpList = res.data.rmOpList.map(
            (rmOp: IRmOps, index: number) => {
              return {
                ...rmOp,
                No: (pageNav.pageNo - 1) * pageNav.pageRows + index + 1,
                brkfInYn:
                  rmOp.brkfInYn === "Y" ? t("included_y") : t("included_n"),
                uYn:
                  rmOp.uyn === "Y"
                    ? t("uyn_y")
                    : rmOp.uyn === "N"
                    ? t("uyn_n")
                    : "--",
                latChkOutTi: timeFormat(rmOp.latChkOutTi),
              };
            }
          );

          setRowData(rmOpList);
          pageNavRef.current = pageNav;
          setIsSuccess(false);
        }

        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  // params 변경,  등록, 수정
  useEffect(() => {
    if (param) {
      mutation.mutate({
        ...param,
        ...pageInitInf,
        lodNo: lod?.lodNo ?? "",
      });
    }
  }, [param]);

  useEffect(() => {
    if (isSuccess) {
      mutation.mutate({
        ...param,
        ...pageInitInf,
        lodNo: lod?.lodNo ?? "",
      });
    }
  }, [isSuccess]);

  // NextPage
  const isCurrent = pageNo?.target === PAGE_ID_ROOM_OPTION;

  useEffect(() => {
    if (isCurrent) {
      const params = {
        ...param,
        lodNo: lod?.lodNo ?? "",
        pageNo: pageNo?.no || 1,
        pageRows: pageNo?.pageRows,
      };

      mutation.mutate(params);
    }
  }, [pageNo?.no, pageNo?.pageRows]);

  return {
    rowData,
    pageNavRef,
  };
};

// 상태변경 mutation
export const useUpdateStatusMutate = () => {
  const { setIsSuccess } = useOptionListContext();
  const handleModal = useModalStore((state) => state.handleModal);
  const onSetAlert = useAlertStore((state) => state.onSetAlert);

  const { t } = useTranslation();
  return useMutation({
    mutationFn: rmOpModifyApi,
    onSuccess: (res, variables) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          // 성공
          onSetAlert({
            isOpen: true,
            inner: t("alt_rm_op_status_done"),
            onSetConfirm: () => {
              // 상태변경 성공, 리스트 조회
              setIsSuccess(true);
              handleModal(false);
            },
          });
        }

        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

export const useUpdateStatus = () => {
  const { mutate } = useUpdateStatusMutate();
  const updateStatus = () => {
    const { listRowInf } = useListRowInfStroe.getState();
    const params = {
      rmNo: listRowInf.no,
      opRgSeq: listRowInf.rgSeq,
      uyn: listRowInf.btnNm.split("_")[1],
      langCd: i18n.language,
    };

    mutate(params);
  };

  return {
    updateStatus,
  };
};
